// extracted by mini-css-extract-plugin
export var emailInputBubbleContainer = "_lj-0";